import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { SensitiveDataPolicy } from '.'

export const sensitiveDataPolicyQuery = gql`
  query SensitiveDataPolicy($organizationID: ID!, $policyID: ID!) {
    sensitiveDataPolicy(organizationID: $organizationID, policyID: $policyID) {
      id
      name
      groupID
      keywords
      enabled
      required
      isDefault
      customKeywords
    }
  }
`

export interface ChildProps {
  readonly loading: boolean
  readonly data?: {
    readonly sensitiveDataPolicy: SensitiveDataPolicy
  }
  readonly refetch?: () => Promise<any>
}

interface Props {
  readonly organizationID: string
  readonly policyID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function EditSensitiveDataPolicyLoader({
  organizationID,
  policyID,
  children
}: Props) {
  return (
    <Query<{
      readonly sensitiveDataPolicy: SensitiveDataPolicy
    }>
      fetchPolicy="network-only"
      query={sensitiveDataPolicyQuery}
      variables={{ organizationID, policyID }}
      errorPolicy="all"
    >
      {({ data, error, loading, refetch }) => {
        if (error) {
          throw new Error(error.message)
        }
        if (loading) {
          return children({ loading })
        }
        if (!data) {
          throw new Error('data is undefined')
        }

        if (!data.sensitiveDataPolicy) {
          throw new Error('sensitiveDataPolicy is undefined')
        }

        const sensitiveDataPolicy: SensitiveDataPolicy = {
          id: data.sensitiveDataPolicy.id,
          name: data.sensitiveDataPolicy.name,
          groupID: data.sensitiveDataPolicy.groupID,
          required: data.sensitiveDataPolicy.required,
          enabled: data.sensitiveDataPolicy.enabled,
          isDefault: data.sensitiveDataPolicy.isDefault,
          keywords: data.sensitiveDataPolicy.keywords,
          customKeywords: data.sensitiveDataPolicy.customKeywords
        }

        return children({
          loading,
          data: { sensitiveDataPolicy },
          refetch
        })
      }}
    </Query>
  )
}
